import { useRef, useEffect, useCallback } from 'react';

/**
 * 防抖回调：在 delay 内重复调用只会执行最后一次。
 * 使用 useRef 保存计时器，避免 useState 导致的闭包旧值问题，并在卸载时清理。
 */
export function useDebounceCallback<T extends (...args: any[]) => any>(
    callback: T,
    delay: number
): T {
    const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
    const callbackRef = useRef(callback);
    useEffect(() => { callbackRef.current = callback; }, [callback]);

    useEffect(() => () => {
        if (timerRef.current) clearTimeout(timerRef.current);
    }, []);

    return useCallback(((...args: Parameters<T>) => {
        if (timerRef.current) clearTimeout(timerRef.current);
        timerRef.current = setTimeout(() => {
            callbackRef.current(...args);
        }, delay);
    }) as T, [delay]);
}
